import chunk from "lodash/chunk";
import { LegacyGetProfilesCollection } from "PFApp/legacy_cv_export_flow";
import { fetchExportProfiles } from "PFCore/services/export_profiles";
import { Id } from "PFTypes";

// Legacy CV export flow, used only when the cv_export_legacy_flow feature flag is ON.
// Meant to be removed together with the flag.
export const getLegacyCvExportSelectedProfilesCollection = (selectedProfileIds: Id[]) =>
  ((paginationPage = 1, paginationSize = 50) => {
    const paginatedIds = chunk(selectedProfileIds, paginationSize);
    return fetchExportProfiles({
      profileIds: paginatedIds[paginationPage - 1]
    }).then((resp) => ({
      entries: resp.map((profile) => ({
        profile
      })),
      meta: { total: selectedProfileIds.length, page: paginationPage }
    }));
  }) as LegacyGetProfilesCollection;
